<template>
  <!-- View project modal template -->
  <b-modal ref="view-guide" @hide="hideGuideModal" size="xl">

    <template #modal-header="{ close }">
      <div class="" style="width: 100%;">
        <span @click="closeModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
          <font-awesome-icon icon="times"/>
        </span>
          <h3 qid="guide-view-title" class="mb-2">
            {{ guide.title }}
          </h3>
      </div>
    </template>

    <div class="mt-4"  style="font-size: 18px;" v-if="guide && guide.id">
      <p class="text-formatted" v-html="guide.description"></p>

      <div v-if="guide.media && guide.media.length" class="mt-3">
        <label>{{ $t('system.media_label') }}</label>
      </div>
      <div v-for="media in guide.media">
        <video width="318" controls :src="media.url"></video>
      </div>
    </div>

    <template #modal-footer="{ close }">
      <div class="" style="width: 100%;">
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="modal-inner-footer">
              <div class="text-right">
                <b-button class="mt-4 float-right"
                          variant="secondary"
                          @click="closeModal"
                          qid="create-p-cancel-button"
                >
                  {{ $t('processes.policies.view.close') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </template>
  </b-modal>

</template>

<script>
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'GuideViewModal',
    data: function() {
      return {
        error: '',
      }
    },
    props: {
      guide: {},
      showModal: {
        type: Boolean
      }
    },
    components: {
      Avatar
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getUser() {
        return this.$store.state.user
      },
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showGuideModal()
        }
      }
    },
    methods: {
      showGuideModal() {
        this.$refs['view-guide'].show()
      },
      hideGuideModal() {
        this.error = ''
        this.$emit('closeViewModal');
        this.$refs['view-guide'].hide()
      },
      closeModal() {
        this.$refs['view-guide'].hide()
      }
    },
    created () {

    }
  }
</script>
